export enum LanguagesEnum {
  No = 'nb-NO',
  En = 'en-GB',
}
